import React, { PropTypes } from 'react';
import FlatButton from '../../../tc-ui/flat-button-with-loader';
import StepperActions from '../stepper-actions';
import RateTemplate from '../rate-tables/rate-table-template-container';
import R, { omit } from 'ramda';
import pluralize from 'pluralize';

const ReviewAdd = ({
  saving,
  componentIndex,
  goToPreviousStep,
  goToNextStep,
  cancelFunc,
  cancelText,
  updateRatesTableCell,
  step3ContinueText,
  onFinish,
  productType,
  paxMax,
  twinBedsAvail,
  ...rateSet,
}) => {

  const invalidRateDescrs = productType === 'Non-Accommodation'
    ? []
    : rateSet.rates.filter(obj => {
      if (obj.notApplicable) return false;
      if (obj.description === 'Twin') return !twinBedsAvail;
      return obj.maxAdults > paxMax;
    })
      .map(obj => obj.description);
  return (
    <div style={{ padding: '24px' }}>
      <div style={{ width: '72%', margin: 'auto' }}>
        We’ve generated this rate table based on what you’ve told us. If you need to fine
        tune these rates, just edit the table below.
      </div>
      <br />

      <div style={{ width: '72%', margin: 'auto' }}>
        <RateTemplate
          productType={productType}
          showHeader
          rateSet={rateSet}
          withEditableCell
          updateTableCell={updateRatesTableCell}
        />
      </div>
      <br />
      {
        Boolean(invalidRateDescrs && invalidRateDescrs.length) && (<div style={{ color: '#ff6200', width: '72%', margin: 'auto' }}>
          The bedding configuration added for this room type does not allow for {invalidRateDescrs.length === 1 ? ' a' : ''} {invalidRateDescrs.join('/')} {pluralize('rate', invalidRateDescrs.length)}. Please update your bedding configuration in the Profile, or unselect {invalidRateDescrs.join('/')} as applicable.
        </div>)
      }
      <br />

      <StepperActions
        showBackButton
        backButtonFunc={() => goToPreviousStep(componentIndex)}
        rightButtons={<div>
        <FlatButton
          label={cancelText}
          labelStyle={{ fontWeight: '600', marginRight: '15px' }}
          primary
          onTouchTap={cancelFunc}
        />
        <FlatButton
          loader={saving}
          onTouchTap={() => {
            if (rateSet.rates.every(rate => rate.notApplicable)) alert('You need to include at least one rate for this rate set to be valid.');
            else onFinish(omit('staypayApplicable', rateSet));
          }}
          secondary
          label={step3ContinueText}
          labelStyle={{ fontWeight: '600' }}
        />
      </div>
      }
      />
    </div>
  );
};

ReviewAdd.propTypes = {
  componentIndex: PropTypes.number,
  goToStep: PropTypes.func,
  cancelFunc: PropTypes.func,
  cancelText: PropTypes.string.isRequired,
  updateRatesTableCell: PropTypes.func,
  step3ContinueText: PropTypes.string,
  onFinish: PropTypes.func,
  ratesTable: PropTypes.object,
};

export default ReviewAdd;



// WEBPACK FOOTER //
// ./src/app/components/contracting/generic-components/add-rates-wizard/3-review-add.jsx